<template>
  <v-app
    :class="{ 'pattern-bg': light, 'pattern-bg-dark': dark }"
    v-if="!loading"
  >
    <v-navigation-drawer
      v-if="menu != 'none'"
      v-model="drawer"
      v-resize="onResize"
      :mini-variant.sync="mini"
      :expand-on-hover="$vuetify.breakpoint.mdAndUp"
      class="elevation-2"
      app
      clipped
    >
      <v-scroll-x-reverse-transition group hide-on-leave>
        <MenuDashBoardColaborador :key="0" v-if="menu === 'dashboard'" />
      </v-scroll-x-reverse-transition>
    </v-navigation-drawer>

    <v-app-bar
      class="elevation-2"
      :class="{ primary: light, 'panel-gradient-bg-dark': dark }"
      app
      clipped-left
      dark
    >
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        @click:outside="drawer = !drawer"
        @keydown.esc="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <h4 class="text-h6">COLABORADOR</h4>

      <v-spacer></v-spacer>
      <v-tooltip v-if="isAdmin" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-2"
            icon
            v-bind="attrs"
            v-on="on"
            :to="{ path: '/admin' }"
          >
            <v-icon> mdi-shield-account </v-icon>
          </v-btn>
        </template>
        <span>Sistema Admin</span>
      </v-tooltip>

      <v-tooltip v-if="isGestor" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-2"
            icon
            v-bind="attrs"
            v-on="on"
            :to="{ path: '/gestor' }"
          >
            <v-icon> mdi-account-cog </v-icon>
          </v-btn>
        </template>
        <span>Sistema Gestor</span>
      </v-tooltip>

      <!-- <v-badge
        class="mr-5"
        :content="count_notificacao"
        :value="count_notificacao"
        color="green"
        overlap
      >
        <v-btn small icon @click="toGoNotificacao">
          <v-icon>
            mdi-bell
          </v-icon>
        </v-btn>
      </v-badge> -->

      <div class="d-flex justify-center align-center mr-3">
        <v-avatar size="30">
          <v-img
            :src="
              store_avatar
                ? store_avatar
                : require('@/assets/avatar_placeholder.png')
            "
          >
          </v-img>
        </v-avatar>

        <div class="ml-2 text-body-1">{{ usuario_name }}</div>
      </div>
      <!-- <div class="d-flex justify-center align-center mr-3"><Notificacao /></div> -->

      <v-btn dark icon @click="menuUsuario = !menuUsuario">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-app-bar>

    <MenuLateralDireitoColaborador
      v-if="menuUsuario"
      :menuUsuario.sync="menuUsuario"
    />

    <v-main style="z-index: 1">
      <transition mode="out-in">
        <router-view />
      </transition>
    </v-main>
    <v-footer
      height="30px"
      app
      inset
      dark
      class="elevation-2"
      :class="{ primary: light, 'panel-gradient-bg-dark': dark }"
    >
    </v-footer>

    <v-card
      tile
      flat
      width="100px"
      height="100px"
      style="background: #eeeeee; position: fixed; right: 0; bottom: 22px"
    >
      <v-img :src="require('@/assets/logo_bg.png')"></v-img>
    </v-card>
  </v-app>
  <v-app v-else>
    <v-main>
      <v-container class="fill-height align-center justify-center">
        <v-progress-circular
          :width="5"
          indeterminate
          :color="dark ? 'white' : 'primary'"
          size="80"
        ></v-progress-circular>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { format } from "date-fns";

export default {
  name: "ColaboradorLayout",
  components: {
    MenuLateralDireitoColaborador: () =>
      import("./components/MenuLateralDireitoColaborador.vue"),
    MenuDashBoardColaborador: () =>
      import("./menus/MenuDashBoardColaborador.vue"),
    // Notificacao: () => import("../../components/notificacao/Notificacao.vue"),
  },
  data() {
    return {
      drawer: true,
      mini: true,
      menuUsuario: false,
      locale: "",
      windowSize: {
        x: 0,
        y: 0,
      },
      apiUrl: null,
      dialogProfile: false,
      menu: "",
      loading: false,
    };
  },

  computed: {
    year() {
      return format(new Date(), "yyyy");
    },
    ...mapState({
      light: (state) => state.template.light,
      dark: (state) => state.template.dark,
    }),
    ...mapGetters("Usuario", ["isAdmin", "isGestor"]),
    ...mapState("Usuario", {
      usuario_name: (state) => state.usuario.name,
      usuario: (state) => state.usuario,
      store_avatar: (state) => state.avatar,
    }),
    // ...mapState("Notificacoes", {
    //   count_notificacao: (state) => state.count_notificacao,
    // }),
    nome() {
      let splitName = this.usuario_name.split(/ /);
      let firstName = splitName[0] ? splitName[0] : "";
      let lastName = splitName[1] ? splitName[1] : "";
      firstName =
        firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
      lastName =
        lastName.charAt(0).toUpperCase() + lastName.slice(1).toLowerCase();
      let name = firstName + " " + lastName;
      return name;
    },
  },

  watch: {
    $route() {
      if (this.$route.meta.menu) {
        this.menu = this.$route.meta.menu;
      }
    },
  },

  methods: {
    ...mapActions("Notificacoes", {
      STORE_count: "count",
    }),
    toGoNotificacao() {
      this.$router.push("/colaborador/notificacoes");
    },
    openDialogShow() {
      this.dialogProfile = true;
    },
    deslogarUsuario() {
      this.loading = true;
      this.$store.dispatch("Usuario/deslogarUsuario").then(() => {
        this.$router.push("/login");
        this.loading = false;
      });
    },
    setTemplate() {
      if (this.light) {
        this.$store.commit("UPDATE_TEMPLATE", { dark: true, light: false });
        this.$ls.set("template", "dark");
        this.$vuetify.theme.dark = true;
      } else {
        this.$store.commit("UPDATE_TEMPLATE", { dark: false, light: true });
        this.$ls.set("template", "light");
        this.$vuetify.theme.dark = false;
      }
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      if (this.windowSize.x < 1264) {
        return (this.mini = false);
      }
    },
  },
  mounted() {
    this.STORE_count();

    if (this.$route.meta.menu) {
      this.menu = this.$route.meta.menu;
    } else {
      this.menu = "dashboard";
    }
    if (process.env.VUE_APP_API_URL) {
      this.apiUrl = process.env.VUE_APP_API_URL;
    }

    this.onResize();
    this.locale = this.$i18n.locale;
  },
};
</script>

<style lang="scss" scoped>
.pattern-bg {
  background-color: #eeeeee !important;
}

.pattern-bg-dark {
  background-color: #3a3a3a !important;
}

.v-enter,
.v-leave-to {
  transform: translate3d(-20px, 0, 0);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
